import { render, staticRenderFns } from "./IconCompensation.vue?vue&type=template&id=f32ee1ce&"
import script from "./IconCompensation.vue?vue&type=script&lang=js&"
export * from "./IconCompensation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports